import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  errorMessages: null,
  total: 0,
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case TYPES.GET_CONCRETE_BATCHES_REQUEST:
      return { ...state, fetching: true, errorMessages: null };

    case TYPES.GET_CONCRETE_BATCHES_SUCCESS:
      return {
        ...state,
        list: payload.data,
        total: payload.total,
        fetching: false,
      };

    case TYPES.GET_CONCRETE_BATCHES_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };
    case TYPES.DELETE_CONCRETE_BATCH_SUCCESS:
      return {
        ...state,
        list: state.list.filter((batch) => batch.id !== payload),
      };
    case TYPES.DELETE_CONCRETE_BATCH_ERROR:
      return {
        ...state,
        errorMessages: payload,
      };
    case TYPES.CREATE_CONCRETE_BATCH_SUCCESS:
      return {
        ...state,
        list: [payload, ...state.list],
        fetching: false,
      };
    case TYPES.CREATE_CONCRETE_BATCH_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };
    default:
      return state;
  }
}
